goog.provide("shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg$default");
shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg$default = shadow.js.shim.module$src$svg$wpp$arrows$chevron_down_svg.default;
